module.exports = __webpack_public_path__ + "static/media/thumb-up-gray.eb4c329d.svg";